import React from 'react';
import ConfigProvider from 'antd/es/config-provider';
import type { Locale } from 'antd/es/locale';
import { ThemeProvider } from '../../styles/theme/ThemeProvider';

/** Static Ant Design APIs render outside the app tree; share its live theme. */
export function configureFeedback(locale?: Locale) {
  ConfigProvider.config({ holderRender: children => <ThemeProvider locale={locale}>{children}</ThemeProvider> });
}
